import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { GalaxyPageModule } from '@vendasta/galaxy/page';
import { MatIconModule } from '@angular/material/icon';
import {
  CompanyTableCustomizationService,
  ContactTableCustomizationService,
  CrmFieldOptionsService,
  CrmFiltersService,
  CrmObjectService,
  DropdownComponent,
  DropdownContentDirective,
  DropdownHeaderDirective,
  RestrictedGroupService,
  TranslateByObjectTypePipe,
  TranslationModule,
} from '@galaxy/crm/static';
import { GalaxyFormFieldModule } from '@vendasta/galaxy/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { ReactiveFormsModule } from '@angular/forms';
import { FIELD_ID_URL_PARAM, OBJECT_TYPE_URL_PARAM } from './constants';
import { MatSelectModule } from '@angular/material/select';
import {
  FieldNamePipe,
  FieldValuePipe,
  FilterInputTypePipe,
  FilterOverridePipe,
  FirstRuleFilterPipe,
  OperatorNamePipe,
  OperatorValueIsRequiredPipe,
  ScoringDefinitionCardComponent,
  ScoringDefinitionCustomFilterOutputComponent,
  ScoringDefinitionFieldIdComponent,
  ScoringDefinitionFieldOperatorComponent,
  ScoringDefinitionFieldValueComponent,
  ScoringDefinitionPageComponent,
  ScoringDefinitionSectionComponent,
  ScoringDefinitionService,
  SupportedOperatorsPipe,
  PointsPipe,
  SignPipe,
} from './scoring-definition';
import { MatTabsModule } from '@angular/material/tabs';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { GalaxyEmptyStateModule } from '@vendasta/galaxy/empty-state';

const OBJECT_ROUTES: Routes = [
  {
    path: `:${OBJECT_TYPE_URL_PARAM}/:${FIELD_ID_URL_PARAM}`,
    component: ScoringDefinitionPageComponent,
  },
];

@NgModule({
  imports: [
    CommonModule,
    RouterModule.forChild(OBJECT_ROUTES),
    GalaxyPageModule,
    MatIconModule,
    DropdownComponent,
    DropdownContentDirective,
    DropdownHeaderDirective,
    GalaxyFormFieldModule,
    MatInputModule,
    MatButtonModule,
    MatSelectModule,
    ReactiveFormsModule,
    TranslationModule,
    MatTabsModule,
    MatAutocompleteModule,
    GalaxyEmptyStateModule,
    ScoringDefinitionFieldValueComponent,
    FilterOverridePipe,
    FilterInputTypePipe,
    TranslateByObjectTypePipe,
  ],
  exports: [RouterModule],
  declarations: [
    ScoringDefinitionPageComponent,
    ScoringDefinitionSectionComponent,
    ScoringDefinitionCardComponent,
    FieldNamePipe,
    SupportedOperatorsPipe,
    OperatorNamePipe,
    FieldValuePipe,
    OperatorValueIsRequiredPipe,
    ScoringDefinitionFieldIdComponent,
    ScoringDefinitionFieldOperatorComponent,
    ScoringDefinitionCustomFilterOutputComponent,
    FirstRuleFilterPipe,
    PointsPipe,
    SignPipe,
  ],
  providers: [
    ScoringDefinitionService,
    CrmFiltersService,
    CrmObjectService,
    CrmFieldOptionsService,
    RestrictedGroupService,
    ContactTableCustomizationService,
    CompanyTableCustomizationService,
  ],
})
export class CrmScoringDefinitionModule {}
